<label
  class="input"
  for="input-{{ id }}"
  [class.focus]="isFocused"
  [class.green]="green"
  [class.error]="error"
>
  <span (click)="focus()"><ng-content></ng-content></span>
  <div class="input-autocomplete-input">
    <div class="flex">
      <input
        [type]="type"
        id="input-{{ id }}"
        [(ngModel)]="value"
        (ngModelChange)="valueChange.emit($event); onChange()"
        (keyup)="onChange($event)"
        (input)="onNativeInput($event)"
        #input
        [disabled]="disabled"
        [focusInput]="autofocus"
        [placeholder]="placeholder"
        [step]="step"
        [min]="_min"
        [max]="_max"
        [attr.inputmode]="inputmode"
        (blur)="emitBlur()"
        (focus)="emitFocus()"
        (blur)="removeFocus()"
        [pattern]="pattern"
        autoComplete="none"
        *ngIf="!textarea && !date"
      />
      <textarea
        id="textarea-{{ id }}"
        [(ngModel)]="value"
        (ngModelChange)="value = $event; valueChange.emit($event); onChange()"
        (keyup)="onChange($event, true)"
        #inputTextarea
        [disabled]="disabled"
        [focusInput]="autofocus"
        [placeholder]="placeholder"
        [attr.inputmode]="inputmode"
        (blur)="emitBlur()"
        (focus)="emitFocus()"
        (blur)="removeFocus()"
        autoComplete="none"
        *ngIf="textarea"
      ></textarea>
      <div *ngIf="date" class="date-input">
        <input
          type="number"
          min="1"
          max="31"
          placeholder="TT"
          (keyup)="dateDayChanged($event)"
          onfocus="this.select()"
        />.<input
          #monthInput
          type="number"
          min="1"
          max="12"
          placeholder="MM"
          (keyup)="dateMonthChanged($event)"
          onfocus="this.select()"
        />.<input
          #yearInput
          min="1900"
          max="2999"
          type="number"
          placeholder="JJJJ"
          (keyup)="dateYearChanged($event)"
          onfocus="this.select()"
        />
      </div>

      <span
        class="action"
        *ngIf="actionLabel && actionLabel.length > 0"
        (click)="emitAction()"
        >{{ actionLabel }}</span
      >
      <span
        class="plus"
        *ngIf="scanner1D"
        alt="Kamera als Scanner verwenden"
        title="Kamera als Scanner verwenden"
        (click)="enableCamera2dScanner(); (false)"
        style="scale: 1.1; padding-top: 1px"
      >
        <span class="icon"><i class="gg-scan"></i></span>
      </span>
      <span class="plus" *ngIf="icon">
        <a class="icon" [href]="iconHref" *ngIf="iconHref"
          ><i [class]="icon"></i
        ></a>
        <span class="icon" *ngIf="!iconHref" (click)="emitAction(true)"
          ><i [class]="icon"></i
        ></span>
      </span>
      <span
        class="plus"
        *ngIf="plus || plusOnMobile"
        [class.hide-desktop]="plusOnMobile"
        (click)="emitEnter()"
      >
        <span class="icon"><i class="gg-add"></i></span>
      </span>
      <span
        class="plus"
        *ngIf="search || searchOnMobile"
        [class.hide-desktop]="searchOnMobile"
        style="margin-left: 0.5rem"
        (click)="emitEnter()"
      >
        <span class="icon"><i class="gg-search"></i></span>
      </span>
    </div>
    <div
      class="input-autocomplete"
      *ngIf="Autocomplete && Autocomplete.length > 0 && isFocused"
    >
      <div
        class="input-autocomplete-entry"
        *ngFor="let c of Autocomplete"
        (click)="runAutocomplete(c)"
      >
        {{ c }}
      </div>
    </div>
  </div>
</label>
<small *ngIf="lengthLimitExceeded"
  >Bitte geben Sie maximal {{ maxLength }} Zeichen an.</small
>

<div
  class="input-barcode-floating-container"
  [class.success]="scannerSuccessVisible"
  [class.error]="scannerErrorVisible"
  *ngIf="camera2dScannerVisible"
>
  <barcode-scanner-livestream
    [type]="['code_128', 'code_39', 'ean', 'code_93']"
    (valueChanges)="camera2dScannerValueChanged($event)"
  ></barcode-scanner-livestream>
  <div class="camera-selector">
    <div (click)="closeCamera2dScanner()">Scanner schließen</div>
  </div>
</div>
